module.exports = __webpack_public_path__ + "img/banner-tc5-m.77e49f3f.jpg";